var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{style:('margin-left: 10px'),attrs:{"color":"info"},on:{"click":_vm.getTemplate}},[_vm._v(" "+_vm._s(_vm.$t('import.downloadTemplate'))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }